import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var CircleMinusIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 17 17" }),
    React.createElement("path", { d: "M8.5 2.5a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1116 0 8 8 0 01-16 0z" }),
    React.createElement("path", { d: "M3.5 8.5a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1z" }))); };

export { CircleMinusIcon as default };
